import * as React from 'react'
type Props = {
  isLoading: boolean
  error: any
  pastDelay: boolean
}

/**
 * Loading component for code splitting that shows loading/error states
 * Used with React.lazy() and Suspense for dynamic imports
 * @param isLoading - Whether the component is currently loading
 * @param error - Error object if loading failed
 * @param pastDelay - Whether the loading delay threshold has been exceeded
 */
const LoadingComponent = ({
  isLoading,
  error,
  pastDelay,
}: Props): null | React.ReactElement<'div'> => {
  if (isLoading) {
    return pastDelay ? <div>Loading...</div> : null
  } else if (error) {
    return <div>Error! Component failed to load</div>
  } else {
    return null
  }
}

export default LoadingComponent
